import React, { useState } from "react";
import Insuarance_card from "./Insuarance_card/Insuarance_card";
import "./Insurance.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Grid, Pagination } from "swiper/modules";
import Visit_btn from "../../Common_Component/Common_Btn/Visit_btn/Visit_btn";

const Insurance = () => {
  const insurancePlans = [
    {
      img: "/assets/Image/Home/insurance/tl_insurance.png",
      label: "TERM LIFE INSURANCE",
    },
    {
      img: "/assets/Image/Home/insurance/health_insurance.png",
      label: "HEALTH INSURANCE",
    },
    {
      img: "/assets/Image/Home/insurance/car_insurance.png",
      label: "CAR INSURANCE",
    },
    {
      img: "/assets/Image/Home/insurance/bike_insurance.png",
      label: "BIKE INSURANCE",
    },
    {
      img: "/assets/Image/Home/insurance/term_insurance.png",
      label: "TERM INSURANCE",
    },
    {
      img: "/assets/Image/Home/insurance/travel_insurance.png",
      label: "TRAVEL INSURANCE",
    },

    {
      img: "/assets/Image/Home/insurance/health_insurance.png",
      label: "HEALTH INSURANCE",
    },
    {
      img: "/assets/Image/Home/insurance/car_insurance.png",
      label: "CAR INSURANCE",
    },
    {
      img: "/assets/Image/Home/insurance/bike_insurance.png",
      label: "BIKE INSURANCE",
    },
    {
      img: "/assets/Image/Home/insurance/term_insurance.png",
      label: "TERM INSURANCE",
    },
    {
      img: "/assets/Image/Home/insurance/travel_insurance.png",
      label: "TRAVEL INSURANCE",
    },
    {
      img: "/assets/Image/Home/insurance/tl_insurance.png",
      label: "TERM LIFE INSURANCE",
    },
  ];

  const [showAll, setShowAll] = useState(false);

  const initialVisibleCards = 8;
  const visibleCards = showAll ? insurancePlans.length : initialVisibleCards;

  return (
    <>
      <section className="Insurance Insurance_desktop_view">
        <div className="container">
          <div className="heading_holder">
            <h4>INSURANCE</h4>
          </div>

          <div className="Insuarance_card_holder">
            <Swiper
              slidesPerView={5}
              grid={{
                rows: 2,
              }}
              spaceBetween={50}
              pagination={{
                clickable: true,
              }}
              modules={[Grid, Pagination, Autoplay]}
              // autoplay={{
              //   delay: 2500,
              //   disableOnInteraction: false,
              // }}
              // loop={true}
              className="mySwiper Insurance_slider"
              breakpoints={{
                0: {
                  slidesPerView: 2.2, // 4 slides on larger screens
                  spaceBetween: 15,
                },

                485: {
                  slidesPerView: 2.5, // 4 slides on larger screens
                  spaceBetween: 15,
                },

                575: {
                  slidesPerView: 2.5, // 4 slides on larger screens
                  spaceBetween: 15,
                },

                768: {
                  slidesPerView: 3.5, // 4 slides on larger screens
                  spaceBetween: 15,
                },

                992: {
                  slidesPerView: 4.5, // 4 slides on larger screens
                  spaceBetween: 25,
                },

                1024: {
                  slidesPerView: 4.5, // 4 slides on larger screens
                  spaceBetween: 25,
                },

                1200: {
                  slidesPerView: 4.5, // 4 slides on larger screens
                  spaceBetween: 25,
                },

                1300: {
                  slidesPerView: 5, // 4 slides on larger screens
                  spaceBetween: 50,
                },
              }}
            >
              {insurancePlans.map((slide) => (
                <SwiperSlide>
                  <Insuarance_card img={slide?.img} title={slide?.label} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>

      {/* Mobile View */}
      <section className="Insurance Insurance_Mobile_view">
        <div className="container">
          <div className="heading_holder">
            <h4>INSURANCE</h4>
          </div>
          <div className="Insuarance_card_holder">
            <div className="row">
              {insurancePlans.slice(0, visibleCards).map((plan, index) => (
                <div
                  key={index}
                  className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-lg-3 mb-md-4 mb-5"
                >
                  <Insuarance_card img={plan?.img} title={plan?.label} />
                </div>
              ))}
            </div>

            <div className="view_all_holder">
              <Visit_btn
                btn_text={
                  showAll
                    ? "View Less Insurance Plans"
                    : "View All Insurance Plans"
                }
                onClick={() => setShowAll(!showAll)}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Insurance;
